"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetectKeySequence = void 0;
const operators_1 = require("./operators");
const rxjs_1 = require("rxjs");
const useDetectKeySequence = (sequence, callback) => {
    const keydownStream = new rxjs_1.Subject();
    const keyUpStream = new rxjs_1.Subject();
    operators_1.keyPressSequence(sequence, keydownStream, keyUpStream).subscribe(() => callback());
    return {
        onKeyUp: event => keyUpStream.next(event),
        onKeyDown: event => keydownStream.next(event)
    };
};
exports.useDetectKeySequence = useDetectKeySequence;
//# sourceMappingURL=use-detect-key-sequence.js.map